import React from 'react';


interface StatusBadgeProps {
  type: 'risk' | 'contract' | 'dd' | 'insurance' | 'issue-status' | 'severity' | 'lifecycle' | 'overall';
  value: string;
  className?: string;
}

function getRiskClass(value: string): string {
  switch (value) {
    case 'Critical': return 'badge badge-critical';
    case 'High': return 'badge badge-high';
    case 'Moderate': return 'badge badge-moderate';
    case 'Low': return 'badge badge-low';
    default: return 'badge badge-draft';
  }
}

function getContractClass(value: string): string {
  switch (value) {
    case 'Active': return 'badge badge-active';
    case 'Expiring': return 'badge badge-expiring';
    case 'Terminated': return 'badge badge-critical';
    case 'Pending Signature': return 'badge badge-pending';
    case 'Legal Review': return 'badge badge-in-progress';
    case 'Negotiation': return 'badge badge-in-progress';
    case 'Draft': return 'badge badge-draft';
    case 'Archived': return 'badge badge-draft';
    default: return 'badge badge-draft';
  }
}

function getDDClass(value: string): string {
  switch (value) {
    case 'Complete': return 'badge badge-complete';
    case 'In Progress': return 'badge badge-in-progress';
    case 'Pending Approval': return 'badge badge-pending';
    case 'Overdue': return 'badge badge-critical';
    case 'Not Started': return 'badge badge-draft';
    case 'Waived': return 'badge badge-low';
    default: return 'badge badge-draft';
  }
}

function getInsuranceClass(value: string): string {
  switch (value) {
    case 'Current': return 'badge badge-active';
    case 'Expiring Soon': return 'badge badge-expiring';
    case 'Expired': return 'badge badge-critical';
    case 'Missing': return 'badge badge-critical';
    case 'Not Required': return 'badge badge-draft';
    default: return 'badge badge-draft';
  }
}

function getIssueStatusClass(value: string): string {
  switch (value) {
    case 'New': return 'badge badge-pending';
    case 'Under Review': return 'badge badge-in-progress';
    case 'Remediation': return 'badge badge-in-progress';
    case 'Pending Validation': return 'badge badge-moderate';
    case 'Closed': return 'badge badge-complete';
    case 'Accepted Risk': return 'badge badge-moderate';
    case 'Escalated': return 'badge badge-critical';
    default: return 'badge badge-draft';
  }
}

function getLifecycleClass(value: string): string {
  switch (value) {
    case 'Active': return 'badge badge-active';
    case 'Onboarding': return 'badge badge-in-progress';
    case 'Due Diligence': return 'badge badge-in-progress';
    case 'Renewal': return 'badge badge-expiring';
    case 'Terminated': return 'badge badge-draft';
    case 'Intake': return 'badge badge-pending';
    case 'Sourcing': return 'badge badge-pending';
    case 'Contracting': return 'badge badge-pending';
    default: return 'badge badge-draft';
  }
}

function getOverallClass(value: string): string {
  switch (value) {
    case 'Good Standing': return 'badge badge-active';
    case 'Needs Attention': return 'badge badge-moderate';
    case 'At Risk': return 'badge badge-high';
    case 'Non-Compliant': return 'badge badge-critical';
    default: return 'badge badge-draft';
  }
}

export default function StatusBadge({ type, value, className = '' }: StatusBadgeProps) {
  let cls = '';
  switch (type) {
    case 'risk': cls = getRiskClass(value); break;
    case 'contract': cls = getContractClass(value); break;
    case 'dd': cls = getDDClass(value); break;
    case 'insurance': cls = getInsuranceClass(value); break;
    case 'issue-status': cls = getIssueStatusClass(value); break;
    case 'severity': cls = getRiskClass(value); break;
    case 'lifecycle': cls = getLifecycleClass(value); break;
    case 'overall': cls = getOverallClass(value); break;
    default: cls = 'badge badge-draft';
  }
  return <span className={`${cls} ${className}`}>{value}</span>;
}